// extracted by mini-css-extract-plugin
export default {"StaffReviewerStatus__statusTag":"sL4Iqzz5gx"};